import React, { useMemo, useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { Copy, X, Check } from 'lucide-react';
import { buildPixPayload } from '../lib/pix';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import { Button } from './ui/button';
import { useToast } from '../hooks/use-toast';

export default function PixModal({ pix, onClose, merchantName }) {
  const [copied, setCopied] = useState(false);
  const { toast } = useToast();

  // Use raw code if provided by admin, else build EMV payload
  const payload = useMemo(() => {
    if (pix.rawCode && pix.rawCode.trim().length > 0) return pix.rawCode.trim();
    return buildPixPayload({
      key: pix.key, amount: pix.amount,
      merchantName: pix.merchantName || merchantName,
      merchantCity: pix.merchantCity || 'SAO PAULO',
      description: pix.title
    });
  }, [pix, merchantName]);

  const copy = async () => {
    await navigator.clipboard.writeText(payload);
    setCopied(true);
    toast({ title: 'Pix copiado!', description: 'Cole no seu app do banco para pagar.' });
    setTimeout(() => setCopied(false), 2500);
  };

  return (
    <Dialog open={true} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="sm:max-w-md bg-white">
        <DialogHeader>
          <DialogTitle className="font-display text-xl">{pix.title}</DialogTitle>
          <DialogDescription>Escaneie o QR Code ou use o Pix copia e cola para pagar.</DialogDescription>
        </DialogHeader>
        <div className="flex flex-col items-center gap-4 py-2">
          <div className="bg-white p-4 rounded-xl border border-neutral-200">
            <QRCodeSVG value={payload} size={220} level="M" includeMargin={false} />
          </div>
          <div className="text-center">
            <div className="text-xs text-neutral-500 uppercase tracking-wider">Chave Pix ({pix.keyType})</div>
            <div className="font-mono text-sm text-neutral-900 mt-0.5">{pix.key || '—'}</div>
            {pix.amount > 0 && (
              <div className="mt-2 text-2xl font-bold text-neutral-900 font-display">
                R$ {Number(pix.amount).toFixed(2).replace('.', ',')}
              </div>
            )}
          </div>
          <div className="w-full">
            <div className="text-xs text-neutral-500 mb-1.5">Pix copia e cola</div>
            <div className="bg-neutral-100 rounded-lg px-3 py-2.5 text-xs font-mono text-neutral-700 break-all max-h-24 overflow-y-auto">{payload}</div>
          </div>
          <Button onClick={copy} className="w-full gap-2 bg-emerald-600 hover:bg-emerald-700 text-white">
            {copied ? <><Check size={16} /> Pix copiado!</> : <><Copy size={16} /> COPIAR PIX</>}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
